
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurancesupersaver/privacy-policy",
      function () {
        return require("private-next-pages/insurancesupersaver/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurancesupersaver/privacy-policy"])
      });
    }
  